import countries from "../../../../core/consts/countries";

function extractPhoneCountryCode(phone: string) {
  for (let i = 0; i < countries.length; i++) {
    const codes = countries[i].countryCallingCodes;
    for (let j = 0; j < codes.length; j++) {
      if (phone.indexOf(codes[j]) === 0) {
        return [codes[j], phone.slice(codes[j].length)];
      }
    }
  }
  return ["", ""];
}
export default extractPhoneCountryCode;
